import {
  OverallHealthEnum,
  ActivityLevelEnum,
  ExerciseFrequencyEnum,
  SmokeUseEnum,
  AlcoholFrequencyEnum,
  WeightUnit,
  HeightUnit
} from './apiGeneratedTypes';

export type LoadingStrategy = 'with_doctor_and_nutritionist';

export const overallHealthOptions = [
  { key: OverallHealthEnum.EXCELLENT, value: 'Excellent' },
  { key: OverallHealthEnum.GOOD, value: 'Good' },
  { key: OverallHealthEnum.FAIR, value: 'Fair' },
  { key: OverallHealthEnum.POOR, value: 'Poor' }
];
export const activityLevelOptions = [
  { key: ActivityLevelEnum.VERY_ACTIVE, value: 'Very Active' },
  { key: ActivityLevelEnum.MODERATELY_ACTIVE, value: 'Moderately Active' },
  { key: ActivityLevelEnum.OCCASIONALLY_ACTIVE, value: 'Occasionally Active' },
  { key: ActivityLevelEnum.NOT_ACTIVE, value: 'Not Active' }
];
export const exerciseFrequencyOptions = [
  { key: ExerciseFrequencyEnum.Daily, value: 'Daily' },
  { key: ExerciseFrequencyEnum.Weekly, value: 'Weekly' },
  { key: ExerciseFrequencyEnum.Occasionally, value: 'Occasionally' },
  { key: ExerciseFrequencyEnum.Never, value: 'Never' }
];
export const smokingStatusOptions = [
  { key: SmokeUseEnum.Yes, value: 'Yes' },
  { key: SmokeUseEnum.No, value: 'No' },
  { key: SmokeUseEnum.Occasionally, value: 'Occasionally' }
];
export const alcoholFrequencyOptions = [
  { key: AlcoholFrequencyEnum.Daily, value: 'Daily' },
  { key: AlcoholFrequencyEnum.Weekly, value: 'Weekly' },
  { key: AlcoholFrequencyEnum.Occasionally, value: 'Occasionally' },
  { key: AlcoholFrequencyEnum.Never, value: 'Never' }
];
export const workingStyleOptions = [
  { key: 'Mostly desk-based', value: 'Mostly desk-based' },
  { key: 'Mostly on the go / active', value: 'Mostly on the go / active' },
  { key: 'A mix of both', value: 'A mix of both' },
  { key: 'Shift-based work', value: 'Shift-based work' },
  { key: 'Other', value: 'Other' }
];
export const dietTypeOptions = [
  { key: 'No specific diet', value: 'No specific diet' },
  { key: 'Vegetarian', value: 'Vegetarian' },
  { key: 'Vegan', value: 'Vegan' },
  { key: 'Pescatarian', value: 'Pescatarian' },
  { key: 'Gluten-free', value: 'Gluten-free' },
  { key: 'Dairy-free', value: 'Dairy-free' },
  { key: 'Low-carb / Keto', value: 'Low-carb / Keto' },
  { key: 'Other', value: 'Other' }
];
export const eatingPatternOptions = [
  { key: 'Regular meals (breakfast, lunch, dinner)', value: 'Regular meals (breakfast, lunch, dinner)' },
  { key: 'Intermittent fasting', value: 'Intermittent fasting' },
  { key: 'Small frequent meals / snacks', value: 'Small frequent meals / snacks' },
  { key: 'Skips meals often / irregular eating', value: 'Skips meals often / irregular eating' },
  { key: 'Varies daily / no fixed pattern', value: 'Varies daily / no fixed pattern' },
  { key: 'Other', value: 'Other' }
];
export const hydrationOptions = [
  { key: 'Mainly water (tap)', value: 'Mainly water (tap)' },
  { key: 'Mainly water (bottled / filtered)', value: 'Mainly water (bottled / filtered)' },
  { key: 'Water + tea/coffee', value: 'Water + tea/coffee' },
  { key: 'Water + soft drinks/energy drinks', value: 'Water + soft drinks/energy drinks' },
  { key: 'Minimal water intake', value: 'Minimal water intake' },
  { key: 'Other', value: 'Other' }
];
export const exerciseRoutineOptions = [
  { key: 'Regular (3+ times a week)', value: 'Regular (3+ times a week)' },
  { key: 'Occasional (1–2 times a week)', value: 'Occasional (1–2 times a week)' },
  { key: 'Rarely (< once a week)', value: 'Rarely (< once a week)' },
  { key: 'Not currently exercising', value: 'Not currently exercising' },
  { key: 'Other', value: 'Other' }
];
export const calmingActivityOptions = [
  { key: 'Meditation', value: 'Meditation' },
  { key: 'Yoga / stretching', value: 'Yoga / stretching' },
  { key: 'Journaling', value: 'Journaling' },
  { key: 'Breathwork', value: 'Breathwork' },
  { key: 'Other', value: 'Other' },
  { key: 'None', value: 'None' }
];

export const medicalImplantOptions = [
  { key: 'Any known metallic piercing/object/shrapnel', value: 'Any known metallic piercing/object/shrapnel' },
  { key: 'Cardiac pacemaker or defibrillator, ICD, cardiac stent or metallic heart valve', value: 'Cardiac pacemaker or defibrillator, ICD, cardiac stent or metallic heart valve' },
  { key: 'Metalwork/clips/coils after fractures or surgery', value: 'Metalwork/clips/coils after fractures or surgery' },
  { key: 'Any joint or limb replacement eg hip/knee', value: 'Any joint or limb replacement eg hip/knee' },
  { key: 'Contraceptive coil (IUD)', value: 'Contraceptive coil (IUD)' },
  { key: 'Internal hearing devices or cochlear implants', value: 'Internal hearing devices or cochlear implants' },
  { key: 'Hydrocephalus shunt, spinal shunt or neurostimulator', value: 'Hydrocephalus shunt, spinal shunt or neurostimulator' },
  { key: 'Any dental implants, fillings, dentures or devices', value: 'Any dental implants, fillings, dentures or devices' },
  { key: 'Any metallic objects or shrapnel in the eye', value: 'Any metallic objects or shrapnel in the eye' },
  { key: 'Specific types of aneurysm clips', value: 'Specific types of aneurysm clips' },
  { key: 'None of the above', value: 'None of the above' }
];

export const practicalConsiderationOptions = [
  { key: 'Claustrophobia or anxiety in enclosed spaces', value: 'Claustrophobia or anxiety in enclosed spaces' },
  { key: 'Diabetes', value: 'Diabetes' },
  { key: 'A known infection risk (e.g. MRSA, active wound)', value: 'A known infection risk (e.g. MRSA, active wound)' },
  { key: 'A mobility requirement', value: 'A mobility requirement' },
  { key: 'A hearing or communication need', value: 'A hearing or communication need' },
  { key: 'Any other requirement we should be aware of', value: 'Any other requirement we should be aware of' },
  { key: 'None of the above', value: 'None of the above' }
];

export const isScanOrPlusMembership = (membershipType?: string | null): boolean => {
  const type = String(membershipType ?? '').toLowerCase().trim();
  return type === 'scan' || type === 'plus';
};

export const ONBOARDING_DECLARATION_ITEMS = [
  'I confirm that all information provided in this form is accurate and complete to the best of my knowledge.',
  'I understand that providing false or incomplete information may affect the safety and accuracy of my scan or test.',
  'I confirm I am aged 18 or over.'
];

/** Extra Scan / Plus declaration points (MRI-specific). */
export const ONBOARDING_SCAN_DECLARATION_ITEMS = [
  'I understand that MRI may not be the most suitable imaging for lungs, breast and the gastrointestinal tract and any lesion smaller than 5mm may not be identified.',
  'I understand that a full body MRI is a screening tool and does not guarantee detection of all conditions. Results will be reviewed by a clinician and communicated to me directly.'
];

export const ONBOARDING_FEMALE_DECLARATION_ITEM =
  'I confirm I am not pregnant, or if there is any possibility I could be pregnant, I will contact the clinic before attending.';

export const getOnboardingDeclarationItems = (
  isFemale: boolean,
  membershipType?: string | null
): string[] => {
  const items = [...ONBOARDING_DECLARATION_ITEMS];
  if (isFemale) {
    // Insert pregnancy confirmation before the age-18 item
    items.splice(2, 0, ONBOARDING_FEMALE_DECLARATION_ITEM);
  }
  if (isScanOrPlusMembership(membershipType)) {
    items.push(...ONBOARDING_SCAN_DECLARATION_ITEMS);
  }
  return items;
};

/** Female hormones step — shown for female members only. */
export const shouldShowFemaleSexHormonesStep = (isFemale: boolean): boolean => isFemale;

/** MRI Scan Safety is Scan / Plus only. Declaration is the final step for all memberships. */
export const getOnboardingTotalSteps = (
  membershipType?: string | null,
  isFemale = false
): number => {
  const isScanOrPlus = isScanOrPlusMembership(membershipType);
  if (isFemale) {
    return isScanOrPlus ? 7 : 6;
  }
  return isScanOrPlus ? 6 : 5;
};

export interface OnboardingFormValues {
  // step 1
  birthDate: Date | null;
  first_name: string;
  last_name: string;
  full_address: string;
  address_line_1: string;
  country: string;
  postalCode: string;
  city: string;
  email: string;
  phone: string;
  weight: string;
  height: string;
  gender: {
    key: any;
    value: any;
  };
  race: {
    key: any;
    value: any;
  };
  weightUnit: {
    key: any;
    value: any;
  };
  heightUnit: {
    key: any;
    value: any;
  };
  // step 2
  overall_health: {
    key: any;
    value: any;
  };
  has_medical_conditions: 'yes' | 'no' | undefined;
  medical_conditions: string;
  medical_conditions_list: string;
  has_surgeries: 'yes' | 'no' | undefined;
  surgeries_details: string;
  has_medications_supplements: 'yes' | 'no' | undefined;
  has_allergies: 'yes' | 'no' | undefined;
  allergies: string;
  medications: string;
  supplements: string;
  activity_level: {
    key: any;
    value: any;
  };
  exercise_frequency: {
    key: any;
    value: any;
  };
  smoking_status: {
    key: any;
    value: any;
  };
  alcohol_frequency: {
    key: any;
    value: any;
  };
  working_style: {
    key: any;
    value: any;
  };
  other_working_style: string;
  diet_types: {
    key: any;
    value: any;
  }[];
  other_diet_type: string;
  eating_pattern: {
    key: any;
    value: any;
  };
  other_eating_pattern: string;
  hydration: {
    key: any;
    value: any;
  };
  other_hydration: string;
  exercise_routine: {
    key: any;
    value: any;
  };
  other_exercise_routine: string;
  calming_activities: {
    key: any;
    value: any;
  }[];
  other_calming_activity: string;

  // MRI Scan Safety (Scan / Plus)
  reason_for_scan: string;
  current_symptoms: string;
  has_cancer_history: 'yes' | 'no' | undefined;
  cancer_history_details: string;
  previous_imaging_details: string;
  scan_family_history_details: string;
  medical_implants: {
    key: any;
    value: any;
  }[];
  medical_implants_details: string;
  practical_considerations: {
    key: any;
    value: any;
  }[];
  practical_considerations_details: string;

  // step family history (legacy)
  family_history_details: string;
  // Goals
  goals: {
    key: any;
    value: any;
  }[];
  health_concerns: {
    key: any;
    value: any;
  }[];
  health_concern_details: string;
  last_blood_test: Date | null;
  additional_info: string;
  pregnancy: boolean;
  any_specific: string;
  // Declaration
  disclaimer_confirmations: Record<string, boolean>;
  // female hormones (legacy)
  last_period_date: Date | null;
  hormonal_contraception_hrt: string;
  typical_cycle_length: string;
  primary_testing_reason: string;
  menstrual_flow_characteristics: string;
  menopause_details: string;
  additional_notes_for_clinical_team: string;
}

export const initialValues: OnboardingFormValues = {
  birthDate: null,
  first_name: '',
  last_name: '',
  full_address: '',
  address_line_1: '',
  country: '',
  postalCode: '',
  city: '',
  email: '',
  phone: '',
  weight: '',
  height: '',
  gender: {
    key: undefined,
    value: undefined
  },
  race: {
    key: undefined,
    value: undefined
  },
  weightUnit: {
    key: WeightUnit.Kg,
    value: 'kg'
  },
  heightUnit: {
    key: HeightUnit.Cm,
    value: 'cm'
  },
  // step 2
  overall_health: {
    key: OverallHealthEnum.EXCELLENT,
    value: undefined
  },
  has_medical_conditions: undefined,
  medical_conditions: '',
  medical_conditions_list: '',
  has_surgeries: undefined,
  surgeries_details: '',
  has_medications_supplements: undefined,
  has_allergies: undefined,
  allergies: '',
  medications: '',
  supplements: '',
  activity_level: {
    key: undefined,
    value: undefined
  },
  exercise_frequency: {
    key: undefined,
    value: undefined
  },
  smoking_status: {
    key: undefined,
    value: undefined
  },
  alcohol_frequency: {
    key: undefined,
    value: undefined
  },
  working_style: {
    key: undefined,
    value: undefined
  },
  other_working_style: '',
  diet_types: [],
  other_diet_type: '',
  eating_pattern: {
    key: undefined,
    value: undefined
  },
  other_eating_pattern: '',
  hydration: {
    key: undefined,
    value: undefined
  },
  other_hydration: '',
  exercise_routine: {
    key: undefined,
    value: undefined
  },
  other_exercise_routine: '',
  calming_activities: [],
  other_calming_activity: '',
  // MRI Scan Safety
  reason_for_scan: '',
  current_symptoms: '',
  has_cancer_history: undefined,
  cancer_history_details: '',
  previous_imaging_details: '',
  scan_family_history_details: '',
  medical_implants: [],
  medical_implants_details: '',
  practical_considerations: [],
  practical_considerations_details: '',
  // legacy family history
  family_history_details: '',
  // Goals
  goals: [],
  health_concerns: [],
  health_concern_details: '',
  last_blood_test: null,
  additional_info: '',
  pregnancy: false,
  any_specific: '',
  // Declaration
  disclaimer_confirmations: {},
  // female hormones (legacy)
  last_period_date: null,
  hormonal_contraception_hrt: '',
  typical_cycle_length: '',
  primary_testing_reason: '',
  menstrual_flow_characteristics: '',
  menopause_details: '',
  additional_notes_for_clinical_team: ''
};


export function normalizeSupplementsFromApi(
  supplements: string | string[] | null | undefined
): string {
  if (supplements == null) return '';
  if (Array.isArray(supplements)) return supplements.filter(Boolean).join(', ');
  return String(supplements).trim();
}
